module.exports = __webpack_public_path__ + "static/media/search_location.a9e53228.svg";